import { canv } from '@/canv/global.js'

export class shapeDocument {

    constructor() {

    }

    fitText(textPart, x, y, width, height, verticalPadding, horizontalPadding) {

        var allowedWidth = width/2 - 2 * horizontalPadding;
        var allowedHeight = height * 5/6 - 2 * verticalPadding;


        textPart.hardWidth = allowedWidth;
        textPart.fitShape();

        textPart.startX = x + width / 2 - textPart.width / 2;
        textPart.startY = y + textPart.lines[0].textHeight + height * 5/6 / 2 - textPart.height / 2;

        textPart.updateDims();

        return {
            "allowedWidth": allowedWidth,
            "allowedHeight": allowedHeight
        };
    }

    draw(x, y, width, height) {
        var r = height / 20;
        if (width < 2 * r) r = width / 2;
        canv.ctx.beginPath();
        canv.ctx.moveTo(x, y + r);
        canv.ctx.arcTo(x, y, x + width, y, r);
        canv.ctx.arcTo(x + width, y, x + width, y + height, r);
        canv.ctx.lineTo(x + width, y + height);

        var r2 = height /5;
        if (width < 5 * r2) r2 = width / 5;

        canv.ctx.arcTo(x + width * 3/4, y + height * 5/6, x + width/4, y + height, r2);
        canv.ctx.arcTo(x + width/4, y + height, x, y + height * 5/6, r2);
        canv.ctx.lineTo(x, y + height * 5/6);
        canv.ctx.lineTo(x, y + r);
    }

    getAvatar(color) {
        return `
        <svg width="105" height="80" viewBox="0 0 105 80" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M103.233 0H1C0.447715 0 0 0.447714 0 0.999999V58.5466C0 58.7839 0.0756122 59.0033 0.231772 59.1821C2.12909 61.354 15.3341 76.0857 27.1912 79.3077C47.1813 84.7397 56.9167 56.2717 77.0417 61.1802C86.8737 63.5782 98.2107 73.5718 102.483 77.6069C103.135 78.2221 104.233 77.7534 104.233 76.8575V1C104.233 0.447715 103.785 0 103.233 0Z"
        fill="` + color + `"/>
        </svg>
        `;
    }

    getView(reason = "shapeToolSubMenu", bgColor = "white", borderColor = "black") {
        let width = 25;
        let height = 25;
        let fill = "white";
        let stroke = "black";

        if (reason === "shapeToolSubMenu") {
            width = 25;
            height = 25;
        } else if (reason === "shapeLibrary") {
            width = 30;
            height = 30;
        } else if (reason === "voteResult") {
            width = 170;
            height = 170;
            fill = bgColor;
            stroke = borderColor;
        }

        return `
            <svg width="` + width + `" height="` + height + `" viewBox="0 0 27 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M25 1H2C1.44772 1 1 1.44772 1 2V14.7627C1 15.0001 1.08399 15.2293 1.24316 15.4054C2.08043 16.3317 4.93484 19.3188 7.52174 20.0217C12.3163 21.3246 14.6513 14.4966 19.4783 15.6739C21.0975 16.0689 22.887 17.3228 24.1813 18.3832C24.8743 18.951 26 18.4675 26 17.5716V2C26 1.44772 25.5523 1 25 1Z" fill="` + fill + `" stroke="` + stroke + `"/>
            </svg>
        `;
    }

}
